import { render, staticRenderFns } from "./UnlockIcon.vue?vue&type=template&id=c8ffad0a&"
import script from "./UnlockIcon.vue?vue&type=script&lang=js&"
export * from "./UnlockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports